import { Request } from '@/classes/Request.ts'

export interface EnrollmentAcceptResponse {
  success: boolean
  data?: {
    action?: string
    cloud_token?: string
    family_user?: {
      family_user_id?: number
      first_name?: string
      last_name?: string
      email?: string
    }
    terms_current?: boolean
    current_terms_id?: number | null
  }
  failure_reason?: string
}

/**
 * Sign an existing invitee in (SOW-46/141). Verifies email + password against
 * the invitation's recipient, links the user, and returns a cloud_token plus the
 * ToS-currency flags so the host can show the re-accept step when needed.
 * POST /api/enrollment/invitation/{token}/accept
 */
export const enrollmentAccept = async (
  token: string,
  payload: { email: string; password: string }
): Promise<EnrollmentAcceptResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/accept`,
    payload
  )
  return response.data
}
